<script setup lang="ts">
interface Props {
  class?: string
}
defineProps<Props>()
</script>

<template>
  <div
    class="flex items-center gap-2 px-4 py-2 border-b border-gray-200 bg-gray-50"
    :class="$props.class"
  >
    <slot />
  </div>
</template>
